<template>
  <section class="row">
    <div class="col-12 text-center">
      <div
        class="mx-auto text-center"
        style="width: 300px"
      >
        <img
          :src="`${aws}/unicorn-magnifying-glass.png`"
          alt="Assurup image loupe"
          class="img-fluid"
        >
      </div>
    </div>
    <div class="col-12 text-center mt-3">
      <slot />
    </div>
  </section>
</template>
<script>
export default {
  computed: {
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
  },
};
</script>
